/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompetitionEntryType } from './CompetitionEntryType';
import {
    CompetitionEntryTypeFromJSON,
    CompetitionEntryTypeFromJSONTyped,
    CompetitionEntryTypeToJSON,
    CompetitionEntryTypeToJSONTyped,
} from './CompetitionEntryType';
import type { GlobalFilterExclusionInput } from './GlobalFilterExclusionInput';
import {
    GlobalFilterExclusionInputFromJSON,
    GlobalFilterExclusionInputFromJSONTyped,
    GlobalFilterExclusionInputToJSON,
    GlobalFilterExclusionInputToJSONTyped,
} from './GlobalFilterExclusionInput';
import type { EntryFeeUnit } from './EntryFeeUnit';
import {
    EntryFeeUnitFromJSON,
    EntryFeeUnitFromJSONTyped,
    EntryFeeUnitToJSON,
    EntryFeeUnitToJSONTyped,
} from './EntryFeeUnit';
import type { TournamentPrizeSplit } from './TournamentPrizeSplit';
import {
    TournamentPrizeSplitFromJSON,
    TournamentPrizeSplitFromJSONTyped,
    TournamentPrizeSplitToJSON,
    TournamentPrizeSplitToJSONTyped,
} from './TournamentPrizeSplit';
import type { CompetitionFaq } from './CompetitionFaq';
import {
    CompetitionFaqFromJSON,
    CompetitionFaqFromJSONTyped,
    CompetitionFaqToJSON,
    CompetitionFaqToJSONTyped,
} from './CompetitionFaq';
import type { TournamentStatus } from './TournamentStatus';
import {
    TournamentStatusFromJSON,
    TournamentStatusFromJSONTyped,
    TournamentStatusToJSON,
    TournamentStatusToJSONTyped,
} from './TournamentStatus';
import type { MatchScoringMode } from './MatchScoringMode';
import {
    MatchScoringModeFromJSON,
    MatchScoringModeFromJSONTyped,
    MatchScoringModeToJSON,
    MatchScoringModeToJSONTyped,
} from './MatchScoringMode';
import type { TournamentFeeMode } from './TournamentFeeMode';
import {
    TournamentFeeModeFromJSON,
    TournamentFeeModeFromJSONTyped,
    TournamentFeeModeToJSON,
    TournamentFeeModeToJSONTyped,
} from './TournamentFeeMode';
import type { TournamentCurrency } from './TournamentCurrency';
import {
    TournamentCurrencyFromJSON,
    TournamentCurrencyFromJSONTyped,
    TournamentCurrencyToJSON,
    TournamentCurrencyToJSONTyped,
} from './TournamentCurrency';
import type { UpdateTournamentBracketSettings } from './UpdateTournamentBracketSettings';
import {
    UpdateTournamentBracketSettingsFromJSON,
    UpdateTournamentBracketSettingsFromJSONTyped,
    UpdateTournamentBracketSettingsToJSON,
    UpdateTournamentBracketSettingsToJSONTyped,
} from './UpdateTournamentBracketSettings';
import type { UpdateTournamentPrizePool } from './UpdateTournamentPrizePool';
import {
    UpdateTournamentPrizePoolFromJSON,
    UpdateTournamentPrizePoolFromJSONTyped,
    UpdateTournamentPrizePoolToJSON,
    UpdateTournamentPrizePoolToJSONTyped,
} from './UpdateTournamentPrizePool';
import type { EntryFeeConfig } from './EntryFeeConfig';
import {
    EntryFeeConfigFromJSON,
    EntryFeeConfigFromJSONTyped,
    EntryFeeConfigToJSON,
    EntryFeeConfigToJSONTyped,
} from './EntryFeeConfig';
import type { Prerequisite } from './Prerequisite';
import {
    PrerequisiteFromJSON,
    PrerequisiteFromJSONTyped,
    PrerequisiteToJSON,
    PrerequisiteToJSONTyped,
} from './Prerequisite';

/**
 * 
 * @export
 * @interface UpdateTournamentBody
 */
export interface UpdateTournamentBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateTournamentBody
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTournamentBody
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTournamentBody
     */
    rules?: string;
    /**
     * 
     * @type {TournamentStatus}
     * @memberof UpdateTournamentBody
     */
    status?: TournamentStatus;
    /**
     * MongoDB ObjectId of the game
     * @type {string}
     * @memberof UpdateTournamentBody
     */
    gameId?: string;
    /**
     * MongoDB ObjectId of the sponsor brand
     * @type {string}
     * @memberof UpdateTournamentBody
     */
    brandId?: string;
    /**
     * MongoDB ObjectId of the parent competition
     * @type {string}
     * @memberof UpdateTournamentBody
     */
    competitionId?: string;
    /**
     * Bracket type for the tournament
     * @type {string}
     * @memberof UpdateTournamentBody
     */
    bracketType?: UpdateTournamentBodyBracketTypeEnum;
    /**
     * Number of players per team
     * @type {number}
     * @memberof UpdateTournamentBody
     */
    teamSize?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTournamentBody
     */
    registrationOpens?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTournamentBody
     */
    registrationCloses?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTournamentBody
     */
    startTime?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTournamentBody
     */
    maxTeams?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTournamentBody
     */
    minTeams?: number;
    /**
     * 
     * @type {CompetitionEntryType}
     * @memberof UpdateTournamentBody
     */
    entryType?: CompetitionEntryType;
    /**
     * 
     * @type {EntryFeeConfig}
     * @memberof UpdateTournamentBody
     */
    entryFeeConfig?: EntryFeeConfig;
    /**
     * Prizes only pay out if at least this many competed. Distinct from minTeams, which gates whether the tournament can start.
     * @type {number}
     * @memberof UpdateTournamentBody
     */
    minParticipants?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTournamentBody
     */
    entryFee?: number;
    /**
     * 
     * @type {TournamentCurrency}
     * @memberof UpdateTournamentBody
     */
    entryFeeCurrency?: TournamentCurrency;
    /**
     * 
     * @type {EntryFeeUnit}
     * @memberof UpdateTournamentBody
     */
    entryFeeUnit?: EntryFeeUnit;
    /**
     * Fee modes a captain may choose from at registration
     * @type {Array<TournamentFeeMode>}
     * @memberof UpdateTournamentBody
     */
    allowedFeeModes?: Array<TournamentFeeMode>;
    /**
     * 
     * @type {TournamentFeeMode}
     * @memberof UpdateTournamentBody
     */
    feeMode?: TournamentFeeMode;
    /**
     * 
     * @type {TournamentPrizeSplit}
     * @memberof UpdateTournamentBody
     */
    prizeSplit?: TournamentPrizeSplit;
    /**
     * 
     * @type {UpdateTournamentPrizePool}
     * @memberof UpdateTournamentBody
     */
    prizePool?: UpdateTournamentPrizePool;
    /**
     * MongoDB ObjectId of the payout table to use
     * @type {string}
     * @memberof UpdateTournamentBody
     */
    payoutTableId?: string;
    /**
     * Per-competition jurisdiction override. Evaluated ALONGSIDE the type default, never instead of it, so it can only tighten. Send an empty string to clear it and inherit the default again.
     * @type {string}
     * @memberof UpdateTournamentBody
     */
    jurisdictionPolicyId?: string;
    /**
     * 
     * @type {UpdateTournamentBracketSettings}
     * @memberof UpdateTournamentBody
     */
    bracketSettings?: UpdateTournamentBracketSettings;
    /**
     * Primary platform for the tournament
     * @type {string}
     * @memberof UpdateTournamentBody
     */
    platform?: string;
    /**
     * Primary region for the tournament
     * @type {string}
     * @memberof UpdateTournamentBody
     */
    region?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTournamentBody
     */
    privacy?: UpdateTournamentBodyPrivacyEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateTournamentBody
     */
    skillLevel?: UpdateTournamentBodySkillLevelEnum;
    /**
     * Minimum age to participate
     * @type {number}
     * @memberof UpdateTournamentBody
     */
    ageRestriction?: number;
    /**
     * Whether check-in is required before tournament starts
     * @type {boolean}
     * @memberof UpdateTournamentBody
     */
    checkInRequired?: boolean;
    /**
     * Minutes before start time when check-in opens
     * @type {number}
     * @memberof UpdateTournamentBody
     */
    checkInWindowMinutes?: number;
    /**
     * URL to tournament stream (Twitch, YouTube, etc.)
     * @type {string}
     * @memberof UpdateTournamentBody
     */
    streamUrl?: string;
    /**
     * Discord invite link for tournament communication
     * @type {string}
     * @memberof UpdateTournamentBody
     */
    discordUrl?: string;
    /**
     * Contact email for tournament support
     * @type {string}
     * @memberof UpdateTournamentBody
     */
    contactEmail?: string;
    /**
     * URL to tournament banner/cover image
     * @type {string}
     * @memberof UpdateTournamentBody
     */
    imageUrl?: string;
    /**
     * Tournament category (e.g., CASUAL, COMPETITIVE, SHOWMATCH)
     * @type {string}
     * @memberof UpdateTournamentBody
     */
    category?: string;
    /**
     * Best-of-X series format (1, 3, 5, etc.)
     * @type {number}
     * @memberof UpdateTournamentBody
     */
    bestOf?: number;
    /**
     * Minutes after registration closes that late registration is allowed
     * @type {number}
     * @memberof UpdateTournamentBody
     */
    lateRegistrationMinutes?: number;
    /**
     * Whether tournament is featured/promoted
     * @type {boolean}
     * @memberof UpdateTournamentBody
     */
    featured?: boolean;
    /**
     * Unix timestamp when featured status expires
     * @type {number}
     * @memberof UpdateTournamentBody
     */
    featuredUntil?: number;
    /**
     * Custom labels for prize positions - keys are placement numbers, values are labels
     * @type {{ [key: string]: string; }}
     * @memberof UpdateTournamentBody
     */
    customPrizeLabels?: { [key: string]: string; };
    /**
     * Skip the 3rd place match in single elimination
     * @type {boolean}
     * @memberof UpdateTournamentBody
     */
    skipConsolationRound?: boolean;
    /**
     * Skip the grand final reset in double elimination
     * @type {boolean}
     * @memberof UpdateTournamentBody
     */
    skipGrandFinalComeback?: boolean;
    /**
     * Skip secondary final round
     * @type {boolean}
     * @memberof UpdateTournamentBody
     */
    skipSecondaryFinal?: boolean;
    /**
     * Multiple platforms allowed for cross-platform tournaments
     * @type {Array<string>}
     * @memberof UpdateTournamentBody
     */
    platforms?: Array<string>;
    /**
     * Multiple regions allowed for cross-region tournaments
     * @type {Array<string>}
     * @memberof UpdateTournamentBody
     */
    regions?: Array<string>;
    /**
     * Whether this tournament recurs on a schedule
     * @type {boolean}
     * @memberof UpdateTournamentBody
     */
    isRecurring?: boolean;
    /**
     * Cron-style or descriptive schedule for recurring tournaments
     * @type {string}
     * @memberof UpdateTournamentBody
     */
    recurringSchedule?: string;
    /**
     * IANA timezone the recurringSchedule's time is interpreted in (default UTC)
     * @type {string}
     * @memberof UpdateTournamentBody
     */
    recurringTimezone?: string;
    /**
     * Whether participants must have a clan tag
     * @type {boolean}
     * @memberof UpdateTournamentBody
     */
    clanTagRequired?: boolean;
    /**
     * Required format for clan tags (regex pattern)
     * @type {string}
     * @memberof UpdateTournamentBody
     */
    clanTagFormat?: string;
    /**
     * MongoDB ObjectId of the match mode configuration
     * @type {string}
     * @memberof UpdateTournamentBody
     */
    matchModeId?: string;
    /**
     * MongoDB ObjectId of the sub-mode configuration
     * @type {string}
     * @memberof UpdateTournamentBody
     */
    subModeId?: string;
    /**
     * Anti-cheat requirements (e.g., "VAC", "EasyAntiCheat")
     * @type {string}
     * @memberof UpdateTournamentBody
     */
    antiCheat?: string;
    /**
     * Eligibility requirements description
     * @type {string}
     * @memberof UpdateTournamentBody
     */
    eligibility?: string;
    /**
     * Name of the ruleset being used
     * @type {string}
     * @memberof UpdateTournamentBody
     */
    ruleset?: string;
    /**
     * URL to full tournament rules document
     * @type {string}
     * @memberof UpdateTournamentBody
     */
    rulesUrl?: string;
    /**
     * Additional notes about platform requirements
     * @type {string}
     * @memberof UpdateTournamentBody
     */
    platformNotes?: string;
    /**
     * Password for private tournaments (will be hashed)
     * @type {string}
     * @memberof UpdateTournamentBody
     */
    password?: string;
    /**
     * MongoDB ObjectId reference to a RuleSet from the rules library (triggers usage count tracking)
     * @type {string}
     * @memberof UpdateTournamentBody
     */
    ruleSetId?: string;
    /**
     * Whether the tournament auto-starts when registration closes and min teams are met
     * @type {boolean}
     * @memberof UpdateTournamentBody
     */
    autoStartEnabled?: boolean;
    /**
     * 
     * @type {Array<CompetitionFaq>}
     * @memberof UpdateTournamentBody
     */
    faqs?: Array<CompetitionFaq>;
    /**
     * 
     * @type {Array<Prerequisite>}
     * @memberof UpdateTournamentBody
     */
    prerequisites?: Array<Prerequisite>;
    /**
     * MongoDB ObjectId of the scoring template that defines how match scores are calculated
     * @type {string}
     * @memberof UpdateTournamentBody
     */
    scoringTemplateId?: string;
    /**
     * 
     * @type {MatchScoringMode}
     * @memberof UpdateTournamentBody
     */
    scoringMode?: MatchScoringMode;
    /**
     * MongoDB ObjectId of the bracket template (blueprint/config) the bracket is generated from
     * @type {string}
     * @memberof UpdateTournamentBody
     */
    bracketTemplateId?: string;
    /**
     * Cheat-filtering match-bracketing gate — when true, scoring events only count while the user has an active Match Start or Round Start in Redis
     * @type {boolean}
     * @memberof UpdateTournamentBody
     */
    requireActiveMatch?: boolean;
    /**
     * IDs of EventPipelineFilter documents to apply to this tournament's events. Layered on top of the game-wide global filter; blocks when any assigned filter votes BLOCK (conditions AND-compose within each filter; exclude conditions block on match, include conditions block on non-match).
     * @type {Array<string>}
     * @memberof UpdateTournamentBody
     */
    appliedFilterIds?: Array<string>;
    /**
     * Break-glass exclusions of GLOBAL filters for this tournament (PRODUCT_PLAN D2(b)). excludedBy and excludedAt are stamped server-side and ignored if sent.
     * @type {Array<GlobalFilterExclusionInput>}
     * @memberof UpdateTournamentBody
     */
    excludedGlobalFilters?: Array<GlobalFilterExclusionInput>;
    /**
     * Rule 4 opt-out. When true this tournament still scores events whose match context is missing. Default false — a tournament that declares what counts should not score events that cannot prove they qualify.
     * @type {boolean}
     * @memberof UpdateTournamentBody
     */
    failOpenOnMissingContext?: boolean;
}


/**
 * @export
 */
export const UpdateTournamentBodyBracketTypeEnum = {
    SINGLE_ELIMINATION: 'SINGLE_ELIMINATION',
    DOUBLE_ELIMINATION: 'DOUBLE_ELIMINATION',
    ROUND_ROBIN: 'ROUND_ROBIN',
    SWISS: 'SWISS'
} as const;
export type UpdateTournamentBodyBracketTypeEnum = typeof UpdateTournamentBodyBracketTypeEnum[keyof typeof UpdateTournamentBodyBracketTypeEnum];

/**
 * @export
 */
export const UpdateTournamentBodyPrivacyEnum = {
    PUBLIC: 'PUBLIC',
    PRIVATE: 'PRIVATE',
    UNLISTED: 'UNLISTED'
} as const;
export type UpdateTournamentBodyPrivacyEnum = typeof UpdateTournamentBodyPrivacyEnum[keyof typeof UpdateTournamentBodyPrivacyEnum];

/**
 * @export
 */
export const UpdateTournamentBodySkillLevelEnum = {
    OPEN: 'OPEN',
    AMATEUR: 'AMATEUR',
    SEMI_PRO: 'SEMI_PRO',
    PRO: 'PRO'
} as const;
export type UpdateTournamentBodySkillLevelEnum = typeof UpdateTournamentBodySkillLevelEnum[keyof typeof UpdateTournamentBodySkillLevelEnum];


/**
 * Check if a given object implements the UpdateTournamentBody interface.
 */
export function instanceOfUpdateTournamentBody(value: object): value is UpdateTournamentBody {
    return true;
}

export function UpdateTournamentBodyFromJSON(json: any): UpdateTournamentBody {
    return UpdateTournamentBodyFromJSONTyped(json, false);
}

export function UpdateTournamentBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTournamentBody {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'rules': json['rules'] == null ? undefined : json['rules'],
        'status': json['status'] == null ? undefined : TournamentStatusFromJSON(json['status']),
        'gameId': json['gameId'] == null ? undefined : json['gameId'],
        'brandId': json['brandId'] == null ? undefined : json['brandId'],
        'competitionId': json['competitionId'] == null ? undefined : json['competitionId'],
        'bracketType': json['bracketType'] == null ? undefined : json['bracketType'],
        'teamSize': json['teamSize'] == null ? undefined : json['teamSize'],
        'registrationOpens': json['registrationOpens'] == null ? undefined : json['registrationOpens'],
        'registrationCloses': json['registrationCloses'] == null ? undefined : json['registrationCloses'],
        'startTime': json['startTime'] == null ? undefined : json['startTime'],
        'maxTeams': json['maxTeams'] == null ? undefined : json['maxTeams'],
        'minTeams': json['minTeams'] == null ? undefined : json['minTeams'],
        'entryType': json['entryType'] == null ? undefined : CompetitionEntryTypeFromJSON(json['entryType']),
        'entryFeeConfig': json['entryFeeConfig'] == null ? undefined : EntryFeeConfigFromJSON(json['entryFeeConfig']),
        'minParticipants': json['minParticipants'] == null ? undefined : json['minParticipants'],
        'entryFee': json['entryFee'] == null ? undefined : json['entryFee'],
        'entryFeeCurrency': json['entryFeeCurrency'] == null ? undefined : TournamentCurrencyFromJSON(json['entryFeeCurrency']),
        'entryFeeUnit': json['entryFeeUnit'] == null ? undefined : EntryFeeUnitFromJSON(json['entryFeeUnit']),
        'allowedFeeModes': json['allowedFeeModes'] == null ? undefined : ((json['allowedFeeModes'] as Array<any>).map(TournamentFeeModeFromJSON)),
        'feeMode': json['feeMode'] == null ? undefined : TournamentFeeModeFromJSON(json['feeMode']),
        'prizeSplit': json['prizeSplit'] == null ? undefined : TournamentPrizeSplitFromJSON(json['prizeSplit']),
        'prizePool': json['prizePool'] == null ? undefined : UpdateTournamentPrizePoolFromJSON(json['prizePool']),
        'payoutTableId': json['payoutTableId'] == null ? undefined : json['payoutTableId'],
        'jurisdictionPolicyId': json['jurisdictionPolicyId'] == null ? undefined : json['jurisdictionPolicyId'],
        'bracketSettings': json['bracketSettings'] == null ? undefined : UpdateTournamentBracketSettingsFromJSON(json['bracketSettings']),
        'platform': json['platform'] == null ? undefined : json['platform'],
        'region': json['region'] == null ? undefined : json['region'],
        'privacy': json['privacy'] == null ? undefined : json['privacy'],
        'skillLevel': json['skillLevel'] == null ? undefined : json['skillLevel'],
        'ageRestriction': json['ageRestriction'] == null ? undefined : json['ageRestriction'],
        'checkInRequired': json['checkInRequired'] == null ? undefined : json['checkInRequired'],
        'checkInWindowMinutes': json['checkInWindowMinutes'] == null ? undefined : json['checkInWindowMinutes'],
        'streamUrl': json['streamUrl'] == null ? undefined : json['streamUrl'],
        'discordUrl': json['discordUrl'] == null ? undefined : json['discordUrl'],
        'contactEmail': json['contactEmail'] == null ? undefined : json['contactEmail'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'category': json['category'] == null ? undefined : json['category'],
        'bestOf': json['bestOf'] == null ? undefined : json['bestOf'],
        'lateRegistrationMinutes': json['lateRegistrationMinutes'] == null ? undefined : json['lateRegistrationMinutes'],
        'featured': json['featured'] == null ? undefined : json['featured'],
        'featuredUntil': json['featuredUntil'] == null ? undefined : json['featuredUntil'],
        'customPrizeLabels': json['customPrizeLabels'] == null ? undefined : json['customPrizeLabels'],
        'skipConsolationRound': json['skipConsolationRound'] == null ? undefined : json['skipConsolationRound'],
        'skipGrandFinalComeback': json['skipGrandFinalComeback'] == null ? undefined : json['skipGrandFinalComeback'],
        'skipSecondaryFinal': json['skipSecondaryFinal'] == null ? undefined : json['skipSecondaryFinal'],
        'platforms': json['platforms'] == null ? undefined : json['platforms'],
        'regions': json['regions'] == null ? undefined : json['regions'],
        'isRecurring': json['isRecurring'] == null ? undefined : json['isRecurring'],
        'recurringSchedule': json['recurringSchedule'] == null ? undefined : json['recurringSchedule'],
        'recurringTimezone': json['recurringTimezone'] == null ? undefined : json['recurringTimezone'],
        'clanTagRequired': json['clanTagRequired'] == null ? undefined : json['clanTagRequired'],
        'clanTagFormat': json['clanTagFormat'] == null ? undefined : json['clanTagFormat'],
        'matchModeId': json['matchModeId'] == null ? undefined : json['matchModeId'],
        'subModeId': json['subModeId'] == null ? undefined : json['subModeId'],
        'antiCheat': json['antiCheat'] == null ? undefined : json['antiCheat'],
        'eligibility': json['eligibility'] == null ? undefined : json['eligibility'],
        'ruleset': json['ruleset'] == null ? undefined : json['ruleset'],
        'rulesUrl': json['rulesUrl'] == null ? undefined : json['rulesUrl'],
        'platformNotes': json['platformNotes'] == null ? undefined : json['platformNotes'],
        'password': json['password'] == null ? undefined : json['password'],
        'ruleSetId': json['ruleSetId'] == null ? undefined : json['ruleSetId'],
        'autoStartEnabled': json['autoStartEnabled'] == null ? undefined : json['autoStartEnabled'],
        'faqs': json['faqs'] == null ? undefined : ((json['faqs'] as Array<any>).map(CompetitionFaqFromJSON)),
        'prerequisites': json['prerequisites'] == null ? undefined : ((json['prerequisites'] as Array<any>).map(PrerequisiteFromJSON)),
        'scoringTemplateId': json['scoringTemplateId'] == null ? undefined : json['scoringTemplateId'],
        'scoringMode': json['scoringMode'] == null ? undefined : MatchScoringModeFromJSON(json['scoringMode']),
        'bracketTemplateId': json['bracketTemplateId'] == null ? undefined : json['bracketTemplateId'],
        'requireActiveMatch': json['requireActiveMatch'] == null ? undefined : json['requireActiveMatch'],
        'appliedFilterIds': json['appliedFilterIds'] == null ? undefined : json['appliedFilterIds'],
        'excludedGlobalFilters': json['excludedGlobalFilters'] == null ? undefined : ((json['excludedGlobalFilters'] as Array<any>).map(GlobalFilterExclusionInputFromJSON)),
        'failOpenOnMissingContext': json['failOpenOnMissingContext'] == null ? undefined : json['failOpenOnMissingContext'],
    };
}

export function UpdateTournamentBodyToJSON(json: any): UpdateTournamentBody {
    return UpdateTournamentBodyToJSONTyped(json, false);
}

export function UpdateTournamentBodyToJSONTyped(value?: UpdateTournamentBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'rules': value['rules'],
        'status': TournamentStatusToJSON(value['status']),
        'gameId': value['gameId'],
        'brandId': value['brandId'],
        'competitionId': value['competitionId'],
        'bracketType': value['bracketType'],
        'teamSize': value['teamSize'],
        'registrationOpens': value['registrationOpens'],
        'registrationCloses': value['registrationCloses'],
        'startTime': value['startTime'],
        'maxTeams': value['maxTeams'],
        'minTeams': value['minTeams'],
        'entryType': CompetitionEntryTypeToJSON(value['entryType']),
        'entryFeeConfig': EntryFeeConfigToJSON(value['entryFeeConfig']),
        'minParticipants': value['minParticipants'],
        'entryFee': value['entryFee'],
        'entryFeeCurrency': TournamentCurrencyToJSON(value['entryFeeCurrency']),
        'entryFeeUnit': EntryFeeUnitToJSON(value['entryFeeUnit']),
        'allowedFeeModes': value['allowedFeeModes'] == null ? undefined : ((value['allowedFeeModes'] as Array<any>).map(TournamentFeeModeToJSON)),
        'feeMode': TournamentFeeModeToJSON(value['feeMode']),
        'prizeSplit': TournamentPrizeSplitToJSON(value['prizeSplit']),
        'prizePool': UpdateTournamentPrizePoolToJSON(value['prizePool']),
        'payoutTableId': value['payoutTableId'],
        'jurisdictionPolicyId': value['jurisdictionPolicyId'],
        'bracketSettings': UpdateTournamentBracketSettingsToJSON(value['bracketSettings']),
        'platform': value['platform'],
        'region': value['region'],
        'privacy': value['privacy'],
        'skillLevel': value['skillLevel'],
        'ageRestriction': value['ageRestriction'],
        'checkInRequired': value['checkInRequired'],
        'checkInWindowMinutes': value['checkInWindowMinutes'],
        'streamUrl': value['streamUrl'],
        'discordUrl': value['discordUrl'],
        'contactEmail': value['contactEmail'],
        'imageUrl': value['imageUrl'],
        'category': value['category'],
        'bestOf': value['bestOf'],
        'lateRegistrationMinutes': value['lateRegistrationMinutes'],
        'featured': value['featured'],
        'featuredUntil': value['featuredUntil'],
        'customPrizeLabels': value['customPrizeLabels'],
        'skipConsolationRound': value['skipConsolationRound'],
        'skipGrandFinalComeback': value['skipGrandFinalComeback'],
        'skipSecondaryFinal': value['skipSecondaryFinal'],
        'platforms': value['platforms'],
        'regions': value['regions'],
        'isRecurring': value['isRecurring'],
        'recurringSchedule': value['recurringSchedule'],
        'recurringTimezone': value['recurringTimezone'],
        'clanTagRequired': value['clanTagRequired'],
        'clanTagFormat': value['clanTagFormat'],
        'matchModeId': value['matchModeId'],
        'subModeId': value['subModeId'],
        'antiCheat': value['antiCheat'],
        'eligibility': value['eligibility'],
        'ruleset': value['ruleset'],
        'rulesUrl': value['rulesUrl'],
        'platformNotes': value['platformNotes'],
        'password': value['password'],
        'ruleSetId': value['ruleSetId'],
        'autoStartEnabled': value['autoStartEnabled'],
        'faqs': value['faqs'] == null ? undefined : ((value['faqs'] as Array<any>).map(CompetitionFaqToJSON)),
        'prerequisites': value['prerequisites'] == null ? undefined : ((value['prerequisites'] as Array<any>).map(PrerequisiteToJSON)),
        'scoringTemplateId': value['scoringTemplateId'],
        'scoringMode': MatchScoringModeToJSON(value['scoringMode']),
        'bracketTemplateId': value['bracketTemplateId'],
        'requireActiveMatch': value['requireActiveMatch'],
        'appliedFilterIds': value['appliedFilterIds'],
        'excludedGlobalFilters': value['excludedGlobalFilters'] == null ? undefined : ((value['excludedGlobalFilters'] as Array<any>).map(GlobalFilterExclusionInputToJSON)),
        'failOpenOnMissingContext': value['failOpenOnMissingContext'],
    };
}

